module.exports = __webpack_public_path__ + "static/demurrage-card-4dcced7e2f46cd3cf3a431cea6c5d288.jpg";